import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetSuggestSearch {
  message: string;
  success: boolean;
  result: [
    {
      search_text: string,
      type: string
    }
  ]
}

interface resGetSearch {
  message: string;
  success: boolean;
  result: [
    {
      news: [news]
    },
    {
      artical: [artical]
    },
    {
      course: [course]
    },
    {
      workshop: [workshop]
    },
    {
      measure: [measure]
    },
    {
      research: [research]
    },
  ]
}

interface news {
  NEWS_ID: number,
  NEWS_TITAL: string,
  NEWS_DETAIL: string,
  NEWS_READED: number,
  NEWS_DATE: Date,
  ADMIN_CREATEID: string,
  NEWS_PIC: string,
  NEWS_STATUS: number,
  NEWS_START: Date,
  NEWS_END: Date,
  NEWS_CATEGORY: string,
  ALWAYS_OPEN: string,
}

interface artical {
  ARTICAL_ID: string,
  ARTICAL_TITAL: string,
  ARTICAL_DETAIL: string,
  ARTICAL_READED: number,
  ARTICAL_DATE: Date,
  ARTICAL_CREATID: string,
  ARTICAL_PIC: string,
  ARTICAL_STATUS: number,
  ARTICAL_START: Date,
  ARTICAL_END: Date,
  ARTICAL_CATEGORY: number,
  ARTICAL_ORIGINAL: string,
  POLL_ID: string,
  CREATE_BY: string,
  ALWAYS_OPEN: string
}

interface course {
  COURSE_ID: string,
  COURSE_NAME: string,
  COURSE_CREATE: Date,
  COURSE_PRICE: number,
  COURSE_TYPE_NAME: string,
  TEACHER_ID: string,
  COURSE_PIC: string,
  COURSE_START: Date,
  COURSE_END: Date,
  COURSE_VDO_EXAMPLE: string,
  COURSE_SPECIALPRICE: number,
  COURSE_COIN_REWARD: number,
  COURSE_COIN_CLOSE: number,
  COURSE_RECOMMEND: string,
  COURSE_DESCRIPTION: string,
  COURSE_STATUS: number,
  ALWAYS_OPEN: string,
  COURSE_PIC_ORIGINAL: string,
  COURSE_VDO_EXAMPLE_NAME: string,
  COURSE_NUMBER: string,
  AVG_POINT: number,
  DULATION: number,
  COUNT_VDO: number,
  COUNT_LESSON: number,
  IS_PREMIUM: boolean,
  USERNAME: string,
}

interface workshop {
  WORKSHOP_ID: string,
  WORKSHOP_NAME: string,
  WORKSHOP_PLACE: string,
  WORKSHOP_COACH: string,
  WORKSHOP_COACH_PIC: string,
  WORKSHOP_PRICE: number,
  WORKSHOP_PHONENUM: string,
  WORKSHOP_DETAIL: string,
  WORKSHOP_QTY_LEARNERS: number,
  WORKSHOP_STATUS: number,
  COUNT_REGIS: number,
  WORKSHOP_PIC: string,
  STATUS_PUBLIC: string,
  WORKSHOP_MINDATE: Date,
  WORKSHOP_FIRST_DAY: Date,
  WORKSHOP_DATE: [
    {
      dateTime: [
        Date,
        Date
      ]
    },
    {
      dateTime: [
        Date,
        Date
      ]
    }
  ]
}

interface measure {
  ALWAYS_OPEN: string,
  COIN: number,
  CREATE_BY: string,
  CREATE_DATE: string,
  DESCRIPTION: string,
  FONT: string,
  IMAGE_MEASURE: string,
  IMAGE_ORIGANAL: string,
  IS_VIEW: number,
  LANGUAGE: string,
  LINK: string,
  MEASURE_END: string,
  MEASURE_ID: string,
  MEASURE_NAME: string,
  MEASURE_START: string,
  MEASURE_TYPE: string,
  QUESTION: string,
  STATUS_MEASURE: number,
  STATUS_PUBLIC: string,
  SUGGESTION_COURSE: string,
  TIME_MEASURE_AGAIN: number,
}

interface research {
  ALWAYS_OPEN: string,
  COIN: number
  COIN_SHARE: number
  CONSENT: string,
  CREATE_BY: string,
  CREATE_DATE: string,
  DOC_ORIGINAL:string,
  IMAGE_ORIGANAL: string,
  IS_VIEW: number
  RESEARCH_DETAIL: string,
  RESEARCH_DOC: string,
  RESEARCH_END: string,
  RESEARCH_ID: string,
  RESEARCH_IMG: string,
  RESEARCH_NAME: string,
  RESEARCH_START: string,
  STATUS_RESEARCH: number
  UPDATE_DATE: string,
  VALUE: string,
  PROGRESS: {
    done: number,
    phase: number,
    sum_measureOfResearch: number
}
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  token: string = null;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getSuggestSearch() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetSuggestSearch>(environment.URL + '/search/getSuggestSearch', { headers });
  }

  getSearch(body) {
    const headers = new HttpHeaders({ Authorization: this.token })
    // console.log(body);

    return this.http.post<resGetSearch>(environment.URL + '/search/getSearch', body, { headers });
  }
}
